export const HASH_OPTIONS = ["MD5", "SHA-1", "SHA-2", "SHA-3", "SHA-256", "SHA-512"];
export const CRYPTOGRAPHY_OPTIONS = [
  "AES", "DES", "RSA", "ELGamal", "Diffie-Hellman", "Caesar", "Homophonic", "Polyalphabetic", "Matrix Cipher"
];